import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { GroupBase, SingleValue } from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';
import cx from 'classnames';

import { SelectOption } from './components';
import styles from './InputSelect.module.sass';

type InputSelectProps = {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  options: SelectOption[] | GroupBase<SelectOption>[];
  className?: string;
  classNamePrefix?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  isError?: boolean;
  isSearchable?: boolean;
  clearable?: boolean;
  onMenuScrollToBottom?: () => void;
  onInputChange?: (value: string) => void;
  inputValue?: string;
  onMenuClose?: () => void;
  formatOptionLabel?: (option: SelectOption) => ReactNode;
  components?: Partial<
    SelectComponents<SelectOption, false, GroupBase<SelectOption>>
  >;
};

const InputSelect: FC<InputSelectProps> = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    onBlur,
    options,
    className = '',
    classNamePrefix = '',
    placeholder = '',
    disabled = false,
    required = false,
    isError = false,
    isSearchable = false,
    clearable = false,
    onMenuScrollToBottom,
    onInputChange,
    inputValue = '',
    onMenuClose,
    formatOptionLabel,
    components,
  } = props;

  const { t } = useTranslation();

  const changeHandler = (newOption: SingleValue<SelectOption>) => {
    onChange(newOption?.value || '');
  };

  const blurHandler = () => {
    onBlur();
  };

  const theValue = (() => {
    for (const item of options) {
      if ('options' in item) {
        const found = (item as GroupBase<SelectOption>).options.find(
          (o) => o.value === value,
        );
        if (found) return found;
      } else if ((item as SelectOption).value === value) {
        return item as SelectOption;
      }
    }
    return null;
  })();

  const selectClassName = cx(className, styles.select, isError && styles.error);
  const selectPlaceholder = placeholder || t('translation.check_asset_label');

  return (
    <Select
      id={id}
      name={name}
      className={selectClassName}
      classNamePrefix={classNamePrefix}
      value={theValue}
      options={options}
      onChange={changeHandler}
      onBlur={blurHandler}
      placeholder={selectPlaceholder}
      isDisabled={disabled}
      required={required}
      components={components}
      isSearchable={isSearchable}
      isClearable={clearable}
      onMenuScrollToBottom={onMenuScrollToBottom}
      onInputChange={onInputChange}
      onMenuClose={onMenuClose}
      inputValue={inputValue}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

export default InputSelect;
